import {Component, OnInit} from '@angular/core';
import {ApiService} from '../service/api.service';
import {UserService} from "../service/user.service";
import {redirect} from "../shared/constants";
import {isEmpty, utf8Decode} from "sdv-common";
import {User} from "../model/user.model";

@Component({
  selector: 'profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  readonly isEmpty = isEmpty;
  loading = true;
  submitted = false;
  user = {
    name: '',
    login: '',
    last: '',
    middle: '',
    first: '',
    attributes: [],

    currentPassword: '',
    currentPasswordVisible: true,
    newPassword: '',
    passwordRequirements: {
      reset: false,
      typing: false,
      number: false,
      length: false,
      unique: false,
      special: false,
      whitespace: false
    },
    repeatPassword: '',

    error: ''
  };
  tab = 'profile';

  constructor(public apiService: ApiService,
              public userService: UserService) {
  }

  ngOnInit() {
    if (this.apiService.isAnonymous()) {
      redirect('/sign-in');
      return;
    }
    this.userService.getUser(this.apiService.getJwtToken().sub)
      .then((user: User) => {
        this.user.name = utf8Decode(user.displayName || '');
        this.user.login = utf8Decode(user.login || '');
        this.user.first = utf8Decode(user.firstName || '');
        this.user.last = utf8Decode(user.lastName || '');
        this.user.middle = utf8Decode(user.middleName || '');
        this.user.attributes = user.attributes || [];

        for (const attribute of this.user.attributes) {
          if (attribute.code === this.userService.resetPwdAttrId) {
            this.user.currentPasswordVisible = false;
            this.tab = 'security';
            break;
          }
        }
        this.loading = false;
      })
      .catch(err => {
        this.apiService.error(this.user, err);
        this.loading = false;
      });
  }

  edit() {
    this.submitted = true;
    if (isEmpty(this.user.name)) {
      return;
    }
    this.submitted = false;
    this.loading = true;

    this.userService.edit(this.apiService.getJwtToken().sub, {
      displayName: this.user.name,
      firstName: this.user.first,
      lastName: this.user.last,
      middleName: this.user.middle,
      login: this.user.login
    }).then(() => {
      this.user.error = '';
      this.loading = false;
    }).catch((err) => {
      this.apiService.error(this.user, err);
      this.loading = false;
    });
  }

  changePassword() {
    this.submitted = true;
    if (this.user.currentPasswordVisible && isEmpty(this.user.currentPassword)) {
      return;
    }
    if (this.user.newPassword.length < 6) {
      return;
    }
    if (this.user.newPassword !== this.user.repeatPassword) {
      return;
    }
    this.submitted = false;
    this.loading = true;

    this.userService.changePassword(this.apiService.getJwtToken().sub, {
      oldPassword: this.user.currentPassword,
      newPassword: this.user.newPassword
    }).then(() => {
      this.user.currentPasswordVisible = true;
      this.user.currentPassword = '';
      this.user.newPassword = '';
      this.user.repeatPassword = '';
      this.user.error = '';
      this.loading = false;
    }).catch((err) => {
      this.apiService.error(this.user, err);
      this.user.currentPassword = '';
      this.user.newPassword = '';
      this.user.repeatPassword = '';
      this.loading = false;
    });
  }

  typingPassword() {
    this.user.passwordRequirements.typing = true;
    if (isEmpty(this.user.newPassword)) {
      this.user.passwordRequirements.reset = true;
    }
    this.user.passwordRequirements.length = this.user.newPassword.length >= 6;
    this.user.passwordRequirements.unique = Array.from(new Set(this.user.newPassword)).length >= 4;
    this.user.passwordRequirements.number = (this.user.newPassword.match(/\d/g) || []).length > 0;
    this.user.passwordRequirements.special = (this.user.newPassword.match(/\W|!|_/g) || []).length > 0;
    this.user.passwordRequirements.whitespace = (this.user.newPassword.match(/\s/g) || []).length === 0;
  }

  metRequirements() {
    const requirements = Object.assign({}, this.user.passwordRequirements);
    delete requirements.reset;
    delete requirements.typing;
    return Object.values(requirements).indexOf(false) === -1;
  }
}
